import React from 'react';

import { useNavigate } from 'react-router-dom';
import { getUrl } from '../../utils/routes';
import { connect } from 'react-redux';
import { getLocals } from '../../utils/locals';

import logo from '../../assets/images/cartoober_logo.svg';
import guy from '../../assets/images/icons/personaje_rostro.png';
import './index.css';

const HeaderFull = props => {
  const { lang } = props.app;
  const locals = getLocals(lang);
  const navigate = useNavigate();
  const onStreamHandler = () => navigate(getUrl('newStream'));
  const onContactHandler = () => navigate(getUrl('contact'));
  const onHomeHandler = () => navigate(getUrl('home'));

  return <div className='header_full'>
    <img onClick={onHomeHandler} className='logo btn' src={logo} alt='Logo cartoober' />
    <div className='header_full__buttons'>
      <span className='btn btn_black' onClick={onStreamHandler}>{locals.stream}</span>
      <span className='btn' onClick={onContactHandler}>
        <img className='icon_image' src={guy} alt='Personaje rostro' />
        {locals.contact}
      </span>
    </div>
  </div>
};

const mapStateToProps = state => ({
  app: state.app
});

export default connect(mapStateToProps)(HeaderFull);